import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    tr: {
        translation: {
            common: {
                brand: "Modelerman",
                languageNames: {
                    tr: "Türkçe",
                    en: "İngilizce",
                },
                languageSwitcherLabel: "Dil",
            },
            home: {
                sections: [
                    {
                        key: "portfolio",
                        title: "PORTFOLYO",
                        summary: "Fotogerçekçi mimari ve peyzaj sahneleriyle satışa hazır sunumlar.",
                        cta: "DETAYLARI GÖR",
                        url: "/portfolio/",
                        color: "#B49B57",
                        accent: "#F5E6C8",
                        img: "https://images.unsplash.com/photo-1526498460520-4c246339dccb?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "services",
                        title: "HİZMETLER",
                        summary: "Sinematik 3D prodüksiyon ve drone sinematografi paketleri.",
                        cta: "DETAYLARI GÖR",
                        url: "/services/",
                        color: "#2E3A59",
                        accent: "#93A4CE",
                        img: "https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "education",
                        title: "EĞİTİM",
                        summary: "Üyelik tabanlı masterclass'ler ve ileri 3D üretim akışı eğitimleri.",
                        cta: "DETAYLARI GÖR",
                        url: "/education/",
                        color: "#8C6A4F",
                        accent: "#D8C0AA",
                        img: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "store",
                        title: "MAĞAZA",
                        summary: "Premium 3D asset koleksiyonları, materyal kütüphaneleri ve plug-in paketleri.",
                        cta: "KOLEKSİYONU AÇ",
                        url: "/store/",
                        color: "#4B255E",
                        accent: "#C8A7E8",
                        img: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1920&q=80",
                    },
                ],
            },
            store: {
                promoCard: {
                    badge: "MAĞAZA",
                    title: "AAA seviyesinde 3D asset ekosistemi",
                    summary:
                        "Fotogerçekçi materyal kütüphaneleri, özel STL koleksiyonları ve sınırlı fiziksel drop'ları tek panelden yönetin.",
                    cta: "TÜM KOLEKSİYİ GÖR",
                    ctaUrl: "/store/#collections",
                    image:
                        "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1920&q=80",
                    accent: "#C8A7E8",
                },
            },
            admin: {
                shell: {
                    logo: "Modelerman Admin",
                    nav: {
                        signature: "Signature Projeler",
                        packages: "Portfolyo Paketleri",
                        services: "Hizmetler",
                        educationSoon: "Eğitim Modülleri (yakında)",
                        showreelSoon: "Showreel (yakında)",
                    },
                    notice:
                        "Supabase bağlantısı kurulduğunda gerçek zamanlı düzenleme ve kullanıcı yönetimi aktif hale gelecek.",
                },
                topbar: {
                    signOut: "Çıkış yap",
                },
                dashboard: {
                    title: "İçerik Kontrol Merkezi",
                    subtitle:
                        "Signature projeler, portfolyo paketleri ve diğer premium içerikleri tek panel üzerinden yönetin. Beta aşamasında olduğumuz için bazı modüller hâlâ hazırlık aşamasında.",
                    tabs: {
                        signature: "Signature Portfolyo",
                        packages: "Portfolyo Paketleri",
                        services: "Hizmetler",
                    },
                },
                login: {
                    title: "İçerik paneline giriş",
                    subtitle: "Yetkili kullanıcılar için giriş ekranı.",
                    usernameLabel: "Kullanıcı adı",
                    passwordLabel: "Şifre",
                    submitIdle: "Giriş yap",
                    submitBusy: "Kontrol ediliyor...",
                    errorFallback: "Giriş yapılamadı. Lütfen tekrar deneyin.",
                    hintPrefix: "Yetkilendirilmiş kullanıcılar için demo kimlik bilgileri:",
                },
            },
            privacy: {
                meta: {
                    title: "Gizlilik Politikası",
                    lastUpdatedLabel: "Son güncelleme",
                    lastUpdatedDate: "5 Kasım 2025",
                },
                hero: {
                    heading: "Modelerman Gizlilik Politikası",
                    summary:
                        "Drone sinematografisi ve peyzaj ağırlıklı 3D prodüksiyon hizmetlerimizi sunarken kişisel verilerinizi şeffaf ve ölçülü şekilde işleriz.",
                },
                sections: [
                    {
                        key: "scope",
                        heading: "Politikanın kapsamı",
                        paragraphs: [
                            "Modelerman, fotogerçekçi peyzaj sahneleri, mimari görselleştirmeler ve drone tabanlı uçuş sinematiği için içerik üreten butik bir stüdyodur.",
                            "Bu politika; web sitemizi (modelerman.com), portföy ve servis sayfalarını ve Supabase ile yönetilen admin panelimizi kapsar.",
                        ],
                    },
                    {
                        key: "dataWeCollect",
                        heading: "Topladığımız veriler",
                        paragraphs: [
                            "Çevrim içi deneyiminizi kişiselleştirebilmek ve taleplerinizi yanıtlayabilmek için sınırlı veri işleriz.",
                        ],
                        bulletsHeading: "Aktif olarak işlediğimiz başlıca veriler:",
                        bullets: [
                            "Dil tercihi: LanguageSwitcher ile seçilen dil tarayıcınızın localStorage alanına kaydedilir.",
                            "Bölge öngörüsü: ModelermanGeo, ipapi.co üzerinden yaklaşık ülke ve dil tahmini yapar; IP adresiniz kalıcı olarak saklanmaz.",
                            "İletişim kayıtları: Bize e-posta veya proje brief'i ilettiğinizde, yanıt süreci boyunca iletişim bilgileriniz ve mesaj içeriği güvenli şekilde saklanır.",
                            "Proje varlıkları: Peyzaj planları, drone çekimleri, CAD dosyaları gibi proje materyalleri yalnızca sözleşmeli proje süresince tutulur.",
                        ],
                    },
                    {
                        key: "landscapeFocus",
                        heading: "Peyzaj ve sahaya özgü veriler",
                        paragraphs: [
                            "Peyzaj odaklı iş akışımız; arazi topoğrafyası, bitki envanteri ya da uçuş izin bilgileri gibi saha hassasiyetlerine saygı duyar.",
                            "Bu tür verileri yalnızca proje üretimi için kullanır, üçüncü kişilerle paylaşmadan önce anonimleştirir veya gerekli izinleri alırız.",
                        ],
                    },
                    {
                        key: "servicesUse",
                        heading: "Verilerin kullanım amaçları",
                        paragraphs: [
                            "Web sitemizde gösterdiğimiz içerikler ve fiyatlandırma önerileri, peyzaj ve drone projelerine yönelik portföyümüzle uyumlu olacak şekilde özelleştirilir.",
                            "İletişim bilgileriniz, yalnızca talep ettiğiniz hizmetler (örneğin premium peyzaj görselleştirme ya da sinematik uçuş çekimi) hakkında geri dönüş yapmak için kullanılır.",
                        ],
                    },
                    {
                        key: "storageSecurity",
                        heading: "Supabase ve depolama güvenliği",
                        paragraphs: [
                            "Admin panelimiz Supabase aracılığıyla yönetilir; platform, proje içeriklerini barındırırken rol tabanlı erişim kontrolleri uygular.",
                            "Sizi tanımlayan bilgiler Supabase'te yalnızca bir iş sürecini yürütmek için zorunlu olduğunda tutulur ve iş tamamlandığında silinir.",
                        ],
                    },
                    {
                        key: "rights",
                        heading: "Haklarınız",
                        paragraphs: [
                            "Kişisel verilerinize erişme, düzeltme, silme veya işlemeyi kısıtlama haklarına sahipsiniz.",
                            "Bu talepleri iletmek için aşağıdaki iletişim kanalından bizimle irtibata geçebilirsiniz; peyzaj projelerine ait hassas veriler için taleplerinizi yazılı olarak doğrulamamız gerekebilir.",
                        ],
                    },
                    {
                        key: "updates",
                        heading: "Politika güncellemeleri",
                        paragraphs: [
                            "Peyzaj ve drone hizmetlerimizi geliştirdikçe gizlilik uygulamalarımızı gözden geçiririz.",
                            "Güncellemeleri bu sayfa üzerinden duyurur ve önemli değişikliklerde sizi tercih ettiğiniz iletişim kanalı üzerinden bilgilendiririz.",
                        ],
                    },
                ],
                contact: {
                    heading: "Sorularınız için",
                    paragraphs: [
                        "Gizlilik uygulamalarımızla ilgili tüm taleplerinizde size yardımcı olmaktan memnuniyet duyarız.",
                    ],
                    emailLabel: "E-posta",
                    email: "privacy@modelerman.com",
                },
            },
        },
    },
    en: {
        translation: {
            common: {
                brand: "Modelerman",
                languageNames: {
                    tr: "Turkish",
                    en: "English",
                },
                languageSwitcherLabel: "Language",
            },
            home: {
                sections: [
                    {
                        key: "portfolio",
                        title: "PORTFOLIO",
                        summary: "Sales-ready presentations with photorealistic architectural and landscape scenes.",
                        cta: "SEE DETAILS",
                        url: "/portfolio/",
                        color: "#B49B57",
                        accent: "#F5E6C8",
                        img: "https://images.unsplash.com/photo-1526498460520-4c246339dccb?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "services",
                        title: "SERVICES",
                        summary: "Cinematic 3D production and drone cinematography packages tailored for premium launches.",
                        cta: "SEE DETAILS",
                        url: "/services/",
                        color: "#2E3A59",
                        accent: "#93A4CE",
                        img: "https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "education",
                        title: "ACADEMY",
                        summary: "Membership-based masterclasses and advanced 3D production pipeline training.",
                        cta: "SEE DETAILS",
                        url: "/education/",
                        color: "#8C6A4F",
                        accent: "#D8C0AA",
                        img: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=1920&q=80",
                    },
                    {
                        key: "store",
                        title: "STORE",
                        summary: "Premium 3D asset collections, material libraries, and plug-in bundles.",
                        cta: "OPEN STORE PANEL",
                        url: "/store/",
                        color: "#4B255E",
                        accent: "#C8A7E8",
                        img: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1920&q=80",
                    },
                ],
            },
            store: {
                promoCard: {
                    badge: "STORE",
                    title: "AAA-grade assets, one vault",
                    summary:
                        "Command photoreal materials, exclusive STL drops, and limited physical editions from a single dashboard.",
                    cta: "BROWSE COLLECTIONS",
                    ctaUrl: "/store/#collections",
                    image:
                        "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1920&q=80",
                    accent: "#C8A7E8",
                },
            },
            admin: {
                shell: {
                    logo: "Modelerman Admin",
                    nav: {
                        signature: "Signature Projects",
                        packages: "Portfolio Packages",
                        services: "Services",
                        educationSoon: "Education Modules (soon)",
                        showreelSoon: "Showreel (soon)",
                    },
                    notice:
                        "When Supabase is connected, real-time editing and user management will be enabled.",
                },
                topbar: {
                    signOut: "Sign out",
                },
                dashboard: {
                    title: "Content Control Center",
                    subtitle:
                        "Manage signature projects, portfolio packages, and other premium content from a single hub. Some modules are still in beta.",
                    tabs: {
                        signature: "Signature Portfolio",
                        packages: "Portfolio Packages",
                        services: "Services",
                    },
                },
                login: {
                    title: "Enter the content panel",
                    subtitle: "Restricted sign-in for authorized users.",
                    usernameLabel: "Username",
                    passwordLabel: "Password",
                    submitIdle: "Sign in",
                    submitBusy: "Checking...",
                    errorFallback: "Sign-in failed. Please try again.",
                    hintPrefix: "Demo credentials for authorized access:",
                },
            },
            privacy: {
                meta: {
                    title: "Privacy Policy",
                    lastUpdatedLabel: "Last updated",
                    lastUpdatedDate: "November 5, 2025",
                },
                hero: {
                    heading: "Modelerman Privacy Policy",
                    summary:
                        "We deliver landscape-led cinematic visualization and drone production services while handling personal data transparently and proportionately.",
                },
                sections: [
                    {
                        key: "scope",
                        heading: "Scope of this policy",
                        paragraphs: [
                            "Modelerman is a boutique studio producing photorealistic landscape scenes, architectural visualizations, and drone-based flight cinematics.",
                            "This policy covers our website (modelerman.com), public portfolio and services pages, and the Supabase-powered admin panel.",
                        ],
                    },
                    {
                        key: "dataWeCollect",
                        heading: "Data we collect",
                        paragraphs: [
                            "We process a limited amount of data to personalize your experience and respond to project inquiries.",
                        ],
                        bulletsHeading: "Key data points we actively handle:",
                        bullets: [
                            "Language preference: the LanguageSwitcher stores your choice in the browser's localStorage.",
                            "Region insight: ModelermanGeo uses ipapi.co to infer an approximate country and language; your IP address is not stored persistently.",
                            "Communication records: when you email us or submit a project brief, we securely store your contact details and message for the duration of the conversation.",
                            "Project assets: landscape plans, drone footage, CAD files, and similar materials are retained only for the duration of the contracted engagement.",
                        ],
                    },
                    {
                        key: "landscapeFocus",
                        heading: "Landscape-specific information",
                        paragraphs: [
                            "Our landscape-focused workflow respects the sensitivity of site data such as topography, planting schedules, or flight permits.",
                            "We use these assets strictly for production, anonymize them before sharing externally, or obtain the necessary approvals first.",
                        ],
                    },
                    {
                        key: "servicesUse",
                        heading: "How we use the data",
                        paragraphs: [
                            "Content and pricing signals displayed on our site are tailored to highlight our landscape visualization and drone production portfolio.",
                            "We use your contact details solely to respond to the services you express interest in, such as premium landscape visuals or cinematic aerial capture.",
                        ],
                    },
                    {
                        key: "storageSecurity",
                        heading: "Storage and security with Supabase",
                        paragraphs: [
                            "Our admin panel runs on Supabase, which hosts project content with role-based access controls.",
                            "Personally identifiable information is kept in Supabase only when required for a production workflow and is deleted once the engagement closes.",
                        ],
                    },
                    {
                        key: "rights",
                        heading: "Your rights",
                        paragraphs: [
                            "You can request access to, correction or deletion of your personal data, or ask us to restrict processing.",
                            "Contact us through the channel below; for sensitive landscape project data, we may need written verification of your request.",
                        ],
                    },
                    {
                        key: "updates",
                        heading: "Policy updates",
                        paragraphs: [
                            "As we evolve our landscape and drone services, we periodically review our privacy practices.",
                            "We announce updates on this page and notify you via your preferred channel when material changes occur.",
                        ],
                    },
                ],
                contact: {
                    heading: "Get in touch",
                    paragraphs: [
                        "We are happy to assist with any questions about how we protect data across our landscape-driven workflows.",
                    ],
                    emailLabel: "Email",
                    email: "privacy@modelerman.com",
                },
            },
        },
    },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: "modelermanGeo",
    lookup() {
        try {
            const geo = window.ModelermanGeo?.getSettings?.();
            if (geo?.language) {
                return geo.language;
            }
        } catch (error) {
            console.warn("i18n: ModelermanGeo lookup failed", error);
        }
        return undefined;
    },
    cacheUserLanguage() {
        // caching handled by default detectors (e.g., localStorage)
    },
});

i18n
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: ["tr", "en"],
        fallbackLng: "tr",
        defaultNS: "translation",
        detection: {
            order: ["localStorage", "querystring", "modelermanGeo", "navigator", "htmlTag"],
            caches: ["localStorage"],
        },
        interpolation: {
            escapeValue: false,
        },
        load: "languageOnly",
    });

export default i18n;
